const FRAME_PADDING = 28

export function getFrameBounds(objects, childIds, padding = FRAME_PADDING) {
  const children = objects.filter((object) => childIds.includes(object.id))
  if (children.length < 2) return null

  const left = Math.min(...children.map((object) => object.x))
  const top = Math.min(...children.map((object) => object.y))
  const right = Math.max(...children.map((object) => object.x + object.w))
  const bottom = Math.max(...children.map((object) => object.y + object.h))

  return {
    x: left - padding,
    y: top - padding - 22,
    w: right - left + padding * 2,
    h: bottom - top + padding * 2 + 22,
  }
}

/**
 * Frames are deliberately a small Canvas-only grouping primitive. They keep
 * a named set of chart IDs and move those charts together, without adding a
 * general whiteboard/grouping system to the production application.
 */
export function createCanvasFrame(objects, childIds, id, name = 'Chart iterations') {
  const bounds = getFrameBounds(objects, childIds)
  if (!bounds) return null
  return { id, kind: 'frame', name, childIds, ...bounds }
}

export function getFrameMoveIds(frame) {
  return [frame.id, ...(frame.childIds || [])]
}

export function removeObjectsFromFrames(objects, removedIds) {
  return objects
    .filter((object) => !removedIds.includes(object.id))
    .map((object) => object.kind === 'frame'
      ? { ...object, childIds: (object.childIds || []).filter((id) => !removedIds.includes(id)) }
      : object)
}
